import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=7445dd9c&scoped=true&"
import script from "./BaseDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=7445dd9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7445dd9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7445dd9c')) {
      api.createRecord('7445dd9c', component.options)
    } else {
      api.reload('7445dd9c', component.options)
    }
    module.hot.accept("./BaseDropdown.vue?vue&type=template&id=7445dd9c&scoped=true&", function () {
      api.rerender('7445dd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseDropdown.vue"
export default component.exports